const messages = {
	yes: 'Yes',
	no: 'No'
};

export default { messages };
